import { FilePurpose } from '../../libs/interfaces/filePurpose';
import { request } from '../../utils/request';

export const getPresignedUrl = (formData: {
  file_type: string;
  file_purpose: FilePurpose;
  authToken: string;
}) =>
  request({
    method: 'POST',
    url: '/files/generate-presigned-url',
    headers: {
      Authorization: `Bearer ${formData.authToken}`,
    },
    formData: {
      file_purpose: formData.file_purpose,
      content_type: formData.file_type,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
